const columnDataGridPieceByStock = [
  {
    dataField: 'qcId',
    caption: '№ СК',
    dataType: 'string'
  },
  {
    dataField: 'cgId',
    caption: '№ партии',
    dataType: 'string'
  },
  {
    dataField: 'actualPieceId',
    caption: '№ УЕ',
    dataType: 'string'
  }
];

export default columnDataGridPieceByStock;
